import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Currency } from 'src/app/models/Lookup';
import Swal from 'sweetalert2';
import { ValueTypeEnum } from '../check-out/CheckOut.models';

@Component({
  selector: 'app-num-keypad',
  templateUrl: './num-keypad.component.html'
})
export class NumKeypadComponent implements OnInit {
  @Input() title!: string;
  @Input() hasPercentage: boolean = false;
  @Input() min!: number;
  @Input() maxLength = 7;
  @Input() currency!: Currency;
  @Output() close = new EventEmitter<any>();

  valueType = 'Value'; // ValueTypeEnum
  @Input() value: any = '';
  initClear = false;
  canClose = true;

  maxPercentageValue = 100;
  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.value = String(this.value)
    if (this.value) {
      this.initClear = true;
    }
  }

  counter(i: number) { return new Array(i); }

  hasPoint(): boolean {
    return this.value.includes('.');
  }


  keyClicked(v: any) {
    this.canClose = false;
    if (this.initClear) {
      this.value = '';
      this.initClear = false;
    }
    let hasPoint = this.hasPoint();
    // if (this.value.length > this.maxLength) { return }
    if (hasPoint && v == '.') { return }
    if (v == '0' && this.value == '0') { return }

    if (!hasPoint && (this.value.length >= this.maxLength) && v != '.') { return }
    if (hasPoint && (this.value.split('.')[1].length == 2)) { return }

    // if (!Number(this.value)) { this.value = '' }
    if (!this.value && v == '0') {
      this.value = '';
    } else if (!this.value && v == '.') {
      this.value = 0 + '.';
    } else {
      this.value = this.value + String(v);
    }
  }

  okClicked(e: any = null) {
    if (e) { e.preventDefault() }
    if (this.value && (this.value.slice(-1) !== '.')
      && Number(this.value)
      && (this.valueType == 'Percentage' && Number(this.value) <= this.maxPercentageValue
        || this.valueType != 'Percentage')) {
      this.close.emit({ value: this.value, valueType: this.valueType })
    } else {
      this.invalidAlert()
    }
  }

  validateValue() {
    let valArr = this.value.split('.');
    if ((valArr[0].length > 7) || (valArr[1].length > 2)) {
      Swal.fire({
        title: this.translate.instant('swalMsg.Warning'),
        text: this.translate.instant('swalMsg.YouShouldAddValidValue'),
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
    }
  }

  invalidAlert() {
    Swal.fire({
      title: this.translate.instant('swalMsg.Warning'),
      text: this.translate.instant('swalMsg.YouShouldAddValidValue'),
      icon: 'error',
      confirmButtonText: this.translate.instant('swalMsg.Ok')
    }).then((result) => {
      this.value = '';
    });
  }

  clear() {
    this.value = '';
  }

  closeNumKeyPad() {
    if (!this.canClose) {
      Swal.fire({
        title: this.translate.instant('swalMsg.are you sure you want to discard all the changes'),
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('swalMsg.Yes'),
        cancelButtonText: this.translate.instant('swalMsg.No'),
      }).then((result) => {
        if (result.value) {
          this.value = '';
          this.close.emit();
          return true;
        } else {
          return false;
        }
      })
    } else {
      this.close.emit()
    }
  }

  @HostListener('window:keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    if (
      e.key == '.'
      || e.key == '0'
      || e.key == '1'
      || e.key == '2'
      || e.key == '3'
      || e.key == '4'
      || e.key == '5'
      || e.key == '6'
      || e.key == '7'
      || e.key == '8'
      || e.key == '9'
    ) {
      this.keyClicked(e.key)
    }
    if (e.key == 'Enter') {
      this.okClicked(e);
    }
    if (e.keyCode == 8 || e.keyCode == 46) {
      this.value = this.value.substring(0, this.value.length - 1);
    }
  }
}
